/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import isMobile from 'is-mobile';
import { Modal } from '~/components';
import BannerDesativacao from '~/assets/stores/banner_desativacao_portal.png';
import BannerDesativacaoWeb from '~/assets/stores/banner_desativacao_portal_web.png';

const ContainerModal = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 0px;
  @media (min-width: ${({ theme }) => theme.devices.desktop}) {
    padding: 0px;
  }
`;

const ContentModal = styled.div`
  flex-direction: column;
  display: flex;
  align-items: center;
  text-align: center;
`;

const ButtonClose = styled.button`
  font-size: 1.2rem;
  font-family: 'Montserrat';
  font-weight: 400;
  color: ${({ theme }) => theme.colors.black};
  border-radius: 100px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  border: none;
  background-color: ${({ theme }) => theme.colors.white};
  -webkit-box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);
  top: -16px;
  right: 16px;
  cursor: pointer;
  @media (min-width: ${({ theme }) => theme.devices.desktop}) {
    right: -16px;
  }
`;

const ImgBannerStyled = styled.img`
  width: 100%;
  height: calc(100% + 25px) !important;
  float: left;
`;

const ModalInactivationPortal = () => {
  const [showModal, setShowModal] = useState(true);
  const contentRef = useRef();

  const validateSession = () => {
    if (sessionStorage.getItem('@vr:showInactivationModal')) {
      setShowModal(false);
    }
  };

  const handleClosemodal = () => {
    setShowModal(false);
    sessionStorage.setItem('@vr:showInactivationModal', true);
  };

  useEffect(() => {
    validateSession();
  }, []);

  return (
    <Modal open={showModal}>
      <ButtonClose onClick={handleClosemodal}>X</ButtonClose>
      <ContainerModal>
        <ContentModal ref={contentRef}>
          <a
            href={
              isMobile()
                ? 'https://bit.ly/phase_out_portal'
                : () => {
                    return false;
                  }
            }
            target="_blank"
            title="Aplicativo SuperApp VR e Você"
            rel="noreferrer"
          >
            <ImgBannerStyled
              src={isMobile() ? BannerDesativacao : BannerDesativacaoWeb}
            />
          </a>
        </ContentModal>
      </ContainerModal>
    </Modal>
  );
};

export default ModalInactivationPortal;
